<!--suppress ALL -->
<template>
  <el-menu class="navbar" mode="horizontal">
<!--    <div style="display: inline-flex;align-items: center;transform: translateY(-5px);padding: 0 40px">-->
      <div style="display: inline-block;text-align: center;transform: translateY(-16px);width: 160px">
        <!--      <img src="https://clourd-static.oss-cn-hangzhou.aliyuncs.com/wap%2Fimgs%2Fatjia.svg" style="width: 48px" alt="">-->
        <h5 style="color:red">星杰云平台后台管理</h5>
      </div>
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :style="{left:sidebar.opened?'200px':'36px'}" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <!--<div>-->
      <!--<img src="../../../assets/images/help.png" alt="">-->
    <!--</div>-->
    <div class="user-info"><img src="../../../assets/images/help.png" alt="" style="width: 20px;height: 20px;float: left;margin-top: 10px;margin-right: 5px;cursor:pointer" @click="help">
      <div class="el-icon-message" @click="viewUserMessage" style="cursor: pointer">
        ({{this.total}}条)未读消息&nbsp;&nbsp;&nbsp;
      </div>
      {{userInfo}}
    </div>

    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="acctHeadUrl">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <!--<el-button size="small" v-if="btnVisiable('/fwAccount/resetPass')" @click="restPassword">密码重置</el-button>-->
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item divided>
            <span @click="updatePwd" style="display:block;">修改密码</span>
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
        <!--<el-dropdown-item divided>-->
          <!--<span  style="display:block;">查看用户消息</span>-->
        <!--</el-dropdown-item>-->
      </el-dropdown-menu>
    </el-dropdown>
    <div>
      <el-dialog :visible.sync="viewUserMessageDialog" width="70%">
        <view-user-message v-if="this.viewUserMessageDialog"></view-user-message>
      </el-dialog>
    </div>
    <div>
      <el-dialog v-loading.lock="loading" title="重置密码" :rules="rules" :visible.sync="restPass" @close="resetpwd">
        <el-form :model="restForm" :rules="rules"  label-width="140px">
          <el-row>
            <el-col :span="10">
              <el-form-item label="新密码" prop="acctPwd">
                <el-input :maxlength="100" v-model="restForm.acctPwd" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="再次输入新密码" prop="newPassword">
                <el-input :maxlength="100" v-model="restForm.newPassword" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item>
              <el-button type="primary" size="small" @click="restAcctPwd">保存</el-button>
              <el-button size="small" @click="resetpwd">关闭</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
    <div data-selectDialog="selectDialog" data-helpDialog="helpDialog">
      <el-dialog :visible.sync="isShow" class="aa" width="100%">
        <preview :preview="preview"></preview>
        <el-button style="float:right" size="small" type="danger" @click="closeDialog">关闭</el-button>
      </el-dialog>
    </div>
  </el-menu>
</template>

<script>
  import listMixins from '@/mixins/form'
  import { mapGetters } from 'vuex'
  import preview from '../../base/help/preview'
  import viewUserMessage from '../../base/help/viewUserMessage'
  export default {
    mixins: [listMixins],
    components: {preview,viewUserMessage},
    computed: {
      userInfo() {
        // const userName = localStorage.getItem('userName') || ''
        // const acctName = localStorage.getItem('acctName') || ''
        const userName = this.$store.getters.userInfo.userName
        const acctName = this.$store.getters.userInfo.acctName
        return `${userName}，您好！ 当前登陆账号：${acctName} `
      },
      ...mapGetters([
        'sidebar',
        'avatar'
      ])
    },
    data() {
      return {
        // logoUrl: require('@/assets/images/touxiang.gif'),
        acctHeadUrl: '',
        pid:'',
        helpId:null,
        isShow : false,
        viewUserMessageDialog: false,
        restPass: false,
        total:'',
        preview:{
          id:'',
          name:'',
          code:'',
          describle:'',
        },
        restForm:　{
          acctPwd: '',
          newPassword: ''
        },
        rules: {
          acctPwd: [
            {required: true, message: '请输入密码', min: 1, max: 50, message: '必填', trigger: 'blur'}
          ],
          newPassword: [
            {required: true, message: '请输入确认密码', min: 1, max: 50, message: '必填', trigger: 'blur'}
          ],
        },
        paramsBack: {
            page: 1,
            pageSize: this.$cache.getConfig("list_page_default_pagesize"),
            orderBy: "id desc",
            totalRows: 0,
            export: false,
            queryParamList: [
                {field: "system",type: "string" ,logic: "like" , value:'0',items: []},
                {field: "isRead",type: "string" ,logic: "like" , value:'0',items: []},
            ]
        },
      }
    },
    created() {

      const headUrl = this.$store.getters.userInfo.headBusinessId
      if(headUrl == "" || headUrl == null){
        this.acctHeadUrl =  require('@/assets/images/userlogo.png')
      }else{
        this.acctHeadUrl = "/"+headUrl
      }
      if (this.$store.getters.userInfo.neverLogin == 1) {
        this.$fetchData(this.$api.BusiMessage.queryUser,this.paramsBack,'post')
          .then(res => {
            this.loading = false
            if (res.totalRows != undefined) {
              this.total = res.totalRows
            }
            this.tableData = res.content
            this.state = true
          }).catch(error => {
          this.loading = false
          this.state = false
        })
      }
    },
    methods: {
      closeDialog(){
        this.isShow=false;
      },
      isContainSpaces(pwd){
        if (pwd.indexOf(" ") == -1) {
          return false;
        } else {
          return true;
        }
      },
      restAcctPwd() {
        if (this.isContainSpaces(this.restForm.acctPwd) || this.isContainSpaces(this.restForm.newPassword)) {
          this.$message.warning("密码不能包含空格");
          return
        }
        let aa = {
          id:this.pid,
          pass: this.restForm.acctPwd,
          pass2: this.restForm.newPassword
        }
        this.loading = true
        this.$fetchData(this.$api.fwAccountList.restAccount,aa ,'post')
          .then(res => {
            this.loading = false
            this.$message.success('修改成功')
            this.restPass=false;
            this.$store.dispatch('logOut').then((res) => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
          .catch(error => {
            this.loading = false
          })
      },
      resetpwd() {
        this.restForm.acctPwd = '';
        this.restForm.newPassword = '';
        this.restPass=false
      },
      viewUserMessage() {
        console.log("222222222222222222222222222222")
        this.viewUserMessageDialog = true
      },
      toggleSideBar() {
        this.$store.dispatch('toggleSideBar')
      },
      logout() {
        this.$fetchData(this.$api.logout).then(resd=>{
          this.$store.dispatch('logOut').then((res) => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })

      },
      updatePwd() {
        if (this.$store.getters.userInfo.neverLogin == 1) {
          this.restPass = true
        }
      },
      help(){
        //获取cookie
        var value = ""
        if(document.cookie.length > 0) {
          var c_start = document.cookie.indexOf("menuId" + "=");//获取字符串的起点
          if(c_start != -1) {
            c_start = c_start + "menuId".length + 1;//获取值的起点
            var c_end = document.cookie.indexOf(";", c_start);//获取结尾处
            if(c_end == -1) c_end = document.cookie.length;//如果是最后一个，结尾就是cookie字符串的结尾
            value = decodeURI(document.cookie.substring(c_start, c_end));//截取字符串返回
          }
        }
        console.log("value:"+value)
        if(value == null || value == ""){
          value = 0
        }
        //获取helpId
        this.$fetchData(this.$api.fwHelp.getBySourceId,{sourceId:value},"get").then(res => {
          if(res){
            console.log(res)
            this.preview = res
            this.isShow = true
          }else{
            this.$message.error('该功能暂时没有帮助提示')
            return
          }
        })
      },
    }
  }
</script>
<style>
  .aa .el-dialog{
    margin-top: 0!important;
  }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  .navbar {
    height: 40px;
    line-height: 40px;
    border-radius: 0px !important;
    background-color: #0B1532;
    position: fixed;
    width: 100%;
    left: 0;
    top:0;
    z-index: 1002;
    font-size: 12px;
    color: #fff;
    overflow: hidden;
    .hamburger-container {
      cursor: pointer;
      position: fixed;
      top:40%;
      overflow: hidden;
      left: 200px;
      transition:left .3s;
    }
    .screenfull {
      position: absolute;
      right: 90px;
      top: 16px;
      color: red;
    }
    .user-info {
      position: absolute;
      display: inline-block;
      right: 100px;
      white-space: nowrap;
    }
    .avatar-container {
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 35px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 30px;
          height: 30px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -15px;
          top: 10px;
          font-size: 15px;
        }
      }
    }
    .avatar-container_area {
      height: 50px;
      line-height: 50px;
      margin-right: 90px;
      float: right;
      margin-top: 3px;
    }


  }
</style>

